import React from 'react';

import {Alert, AlertTitle, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

/**
 * Error Alert Component
 * @return {ReactElement}
 */
export default function ErrorAlert({afterSlot = null, reason, showTitle = true}) {
  const {t} = useTranslation();
  return (
    <>
      {showTitle && <Typography variant="h5" fontWeight="bold" marginBottom={2} marginTop={1}>
        {t('common.error')}
      </Typography>}

      <Alert
        severity="error"
        variant="standard"
        sx={{
          borderRadius: 3,
        }}
      >
        <AlertTitle>
          <Typography>
            <b>{reason}</b>
          </Typography>
        </AlertTitle>
        {afterSlot}
      </Alert>
    </>
  );
}
